// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import cartLineSharedStyles from "@rpsc/App/SharedStyles/CartLineSharedStyles";
import { requisitionsProductListLineStyles } from "@rpsc/Overrides/Widgets/Requisitions/RequisitionsProductListLine";
import { color, mergeWithCss, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

requisitionsProductListLineStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};
requisitionsProductListLineStyles.productPriceStyles = {
    ...cartLineSharedStyles.productPrice,
};
requisitionsProductListLineStyles.subtotalHeadingAndText = {
    ...cartLineSharedStyles.extendedUnitNetPriceHeadingAndText?.extendedStyles,
};
requisitionsProductListLineStyles.productPartNumbersStyles = {
    ...cartLineSharedStyles.productPartNumbers,
};

requisitionsProductListLineStyles.productImageStyles = {
    ...mergeWithCss(cartLineSharedStyles.productImage, {
        linkWrappingImage: {
            css: css`
                width: 120px;
                height: 120px;
            `,
        },
    }),
};

requisitionsProductListLineStyles.requisitionLinesAccordion = {
    mergeCss: true,
    css: css`
        margin-top: 10px;
    `,
};

requisitionsProductListLineStyles.GridContainer = {
    container: {
        css: css`
            &&& {
                grid-template-columns: 140px minmax(0, 358px) minmax(0, 166px) minmax(0, 92px) minmax(0, 146px) minmax(
                        0,
                        22px
                    );

                position: relative;
                padding: 12px;
                margin-bottom: 12px;
                border: none;
            }
        `,
    },
    image: {
        css: css`
            margin-left: 25px;
        `,
    },
    description: {
        css: css`
            ${xScreen("gt", "sm")} {
                ${({ isCondensed }: any) => (!isCondensed ? "grid-column: 2 / 3;" : " grid-column: 1 / 3;")};
            }
        `,
    },
    price: {
        css: css`
            ${xScreen("gt", "sm")} {
                grid-column: 3 / 4;
                grid-row: 1 / 2;
                margin-top: 4px;
            }
        `,
    },
    qty: {
        css: css`
            ${xScreen("gt", "sm")} {
                grid-column: 4 / 5;
                grid-row: 1 / 2;
                padding-right: 12px;
            }
        `,
    },
    total: {
        css: css`
            ${xScreen("gt", "sm")} {
                grid-column: 5 / 6;
                grid-row: 1 / 2;
                padding-right: 12px;
                margin-top: 4px;
            }
        `,
    },
};

requisitionsProductListLineStyles.selectedCheckbox = {
    css: css`
        position: absolute;
        left: 12px;
        top: 12px;
    `,
};

requisitionsProductListLineStyles.requisitionLinesAccordion = {
    css: css`
        padding: 0;
    `,
};

requisitionsProductListLineStyles.lineHeader = {
    wrapper: {
        css: css`
            && {
                grid-template-columns: 140px minmax(0, 358px) minmax(0, 166px) minmax(0, 92px) minmax(0, 146px) minmax(
                        0,
                        22px
                    );
            }
            ${xScreen("gt", "sm")} {
                display: grid;
                grid-column-gap: 15px;
            }
        `,
    },
    itemDescription: {
        css: css`
            ${xScreen("gt", "sm")} {
                grid-column: 1 / 3;
            }
        `,
    },
    qty: {
        css: css`
            ${xScreen("gt", "sm")} {
                display: block;
            }
        `,
    },
    total: {
        css: css`
            ${xScreen("gt", "sm")} {
                display: block;
            }
        `,
    },
    priceUnit: {
        css: css`
            ${xScreen("gt", "sm")} {
                display: block;
            }
        `,
    },
};
